var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgDotnet = function SvgDotnet(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.983 18.585c1.656 5.065 2.284 14.1 7.127 14.1.368 0 .742-.036 1.115-.107-4.402-1.027-4.924-9.964-7.611-14.592-.214.195-.425.395-.631.599Z",
    fill: "url(#dotnet_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.614 17.986c2.687 4.628 3.209 13.565 7.611 14.592.354-.067.701-.161 1.04-.281-3.952-1.937-5.044-10.615-8.095-14.793-.185.154-.37.315-.556.482Z",
    fill: "url(#dotnet_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.485 15.234c-.367 0-.741.036-1.116.107-.98.185-1.976.607-2.98 1.245.275.271.536.58.781.918 1.021-.847 2.035-1.473 3.045-1.85a6.818 6.818 0 0 1 1.136-.315 3.524 3.524 0 0 0-.866-.105Z",
    fill: "#14559A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.35 30.512c.421-.336.827-.691 1.215-1.065-1.683-5.04-2.285-14.206-7.162-14.206-.35 0-.7.033-1.052.098 4.443 1.105 5.012 10.77 7 15.173Z",
    fill: "url(#dotnet_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.352 15.339a3.507 3.507 0 0 0-.867-.106l1.918.007c-.349 0-.7.033-1.051.099Z",
    fill: "#3092C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.265 31.583a7.3 7.3 0 0 1-.55-.594c-.82.58-1.638 1.021-2.45 1.308a3.774 3.774 0 0 0 1.692.388c.912 0 1.632-.108 2.245-.402a4.278 4.278 0 0 1-.937-.7Z",
    fill: "#1969BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.215 15.655c3.979 2.082 4.325 11.507 7.5 15.334.213-.15.424-.31.634-.477-1.987-4.403-2.555-14.07-6.997-15.173a6.9 6.9 0 0 0-1.137.316Z",
    fill: "url(#dotnet_svg__d)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.17 17.504c3.051 4.178 4.143 12.857 8.095 14.793.813-.287 1.63-.727 2.45-1.308-3.175-3.827-3.521-13.252-7.5-15.334-1.01.376-2.024 1.002-3.045 1.85Z",
    fill: "url(#dotnet_svg__e)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.031 18.463c-.478 1.08-.967 2.502-1.557 4.357 1.174-1.654 2.345-3.08 3.509-4.235-.147-.46-.32-.912-.518-1.352-.5.383-.979.794-1.434 1.23Z",
    fill: "url(#dotnet_svg__f)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.889 16.92c-.14.1-.282.204-.424.312.186.405.358.86.518 1.353.207-.203.417-.403.631-.599a8.37 8.37 0 0 0-.725-1.066Z",
    fill: "#2B74B1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.39 16.586c-.167.106-.333.217-.502.334.261.32.5.679.726 1.067.186-.168.371-.33.556-.483a7.438 7.438 0 0 0-.78-.918Z",
    fill: "#125A9E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.532 14.848c-2.25 8.679-6.951 15.65-10.892 17.407h-.008l-.212.091-.026.01-.06.024-.028.011-.098.035-.04.014-.05.016-.047.017-.042.014-.084.026-.036.009-.057.015-.038.01-.062.017-.076.016c.178.066.364.1.564.1 3.737 0 7.505-6.697 13.74-17.834H44.53v.002Z",
    fill: "url(#dotnet_svg__g)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m12.662 15.586.007-.006.009-.005h.005l.06-.024.012-.006.016-.006.065-.023h.003l.144-.05.021-.006.062-.019.028-.009.062-.018.023-.006.206-.053.028-.007.06-.012.03-.008.06-.012h.014l.125-.023h.024l.058-.01.033-.006.055-.008.03-.006.135-.012a4.297 4.297 0 0 0-.398-.02c-4.209 0-10.007 7.808-12.619 17.92h.504a146.42 146.42 0 0 0 2.273-4.225c1.83-7.162 5.555-12.047 8.865-13.34",
    fill: "url(#dotnet_svg__h)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.031 18.463c.455-.436.934-.847 1.434-1.23a6.715 6.715 0 0 0-.342-.661c-.385.467-.737 1.084-1.092 1.89ZM15.377 15.645c.275.23.521.548.746.927.071-.087.143-.167.218-.243a4.219 4.219 0 0 0-1.017-.711l.045.021.008.006Z",
    fill: "#0D82CA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.798 28.927c3.837-7.395 5.655-12.075 8.865-13.342-3.31 1.296-7.036 6.18-8.865 13.342Z",
    fill: "url(#dotnet_svg__i)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.34 16.33a3.848 3.848 0 0 0-.217.243c.12.201.233.421.342.66.142-.11.284-.212.424-.313a5.755 5.755 0 0 0-.549-.59Z",
    fill: "#127BCA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m5.54 33.118-.07.008h-.013l-.06.006h-.009l-.141.01h-.015c3.884-.11 5.66-2.054 6.54-4.874.67-2.138 1.22-3.94 1.702-5.45-1.627 2.289-3.261 5.018-4.904 8.076-.792 1.474-1.997 2.09-3.03 2.221",
    fill: "url(#dotnet_svg__j)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54 33.117c1.033-.132 2.238-.747 3.03-2.221 1.643-3.057 3.278-5.787 4.903-8.077.591-1.856 1.08-3.277 1.558-4.358-3.24 3.084-6.492 8.21-9.491 14.654",
    fill: "url(#dotnet_svg__k)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.798 28.927c-.735 1.42-1.493 2.83-2.274 4.225h1.464c.185-1.423.455-2.834.81-4.224",
    fill: "#05A1E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m13.902 15.266-.03.006-.055.008-.033.006-.057.01-.025.006-.125.021h-.014l-.061.012-.03.009-.06.011-.027.007-.206.053-.024.007-.062.018-.028.008-.061.019-.023.006-.142.05-.065.022-.027.012-.06.022-.02.01c-3.21 1.266-5.028 5.946-8.866 13.34-.354 1.391-.625 2.802-.809 4.225h.205l1.408-.006h.647l.14-.01h.01l.058-.005h.014l.07-.009c3-6.443 6.252-11.57 9.491-14.654.357-.807.708-1.423 1.092-1.89-.225-.38-.471-.697-.746-.928l-.007-.006-.046-.022-.046-.023-.043-.022-.053-.021-.04-.018-.085-.035-.037-.014-.063-.025-.034-.012-.088-.03h-.007l-.102-.029-.023-.007-.086-.024-.02-.006a2.94 2.94 0 0 0-.213-.047l-.022-.006-.093-.015-.018-.005-.11-.015h-.02l-.084-.01-.134.013",
    fill: "url(#dotnet_svg__l)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.742 19.653c-.74 2.365-1.337 4.316-1.857 5.921 2.026-2.788 4.021-6.295 5.922-10.342-2.218.697-3.4 2.29-4.066 4.42Z",
    fill: "url(#dotnet_svg__m)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.949 32.108a6.676 6.676 0 0 1-.309.148c3.94-1.758 8.642-8.73 10.892-17.408h-.456c-5.17 9.236-6.834 15.42-10.127 17.26Z",
    fill: "url(#dotnet_svg__n)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.375 31.332c.858-1.047 1.556-2.826 2.51-5.758-1.1 1.511-2.207 2.81-3.315 3.869l-.006.01c.242.723.507 1.363.81 1.879",
    fill: "#079AE1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.375 31.332a3.51 3.51 0 0 1-.944.828 3.34 3.34 0 0 1-.229.123c.373.202.781.33 1.202.38l.197.016h.012l.094.006h.32l.037-.006.07-.006h.035l.077-.008h.007l.023-.005.082-.013h.024l.093-.016h.015l.184-.039c-.51-.186-.935-.625-1.301-1.25",
    fill: "#1969BC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.11 32.685c.369 0 .742-.036 1.116-.108.353-.066.7-.16 1.04-.28a3.817 3.817 0 0 0 1.691.389h-3.846Zm3.847 0c.911 0 1.633-.108 2.245-.402.373.202.781.331 1.202.38l.197.016h.012l.094.006h.113-3.863Z",
    fill: "#1E5CB3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.82 32.685h.21l.037-.006.072-.006h.034l.077-.008h.006l.023-.006.082-.012.026-.006.092-.015h.015l.184-.039c.178.066.364.1.564.1l-1.42.005-.002-.007Z",
    fill: "#1D60B5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.567 29.453v-.006c-.389.373-.794.728-1.215 1.065-.207.165-.42.323-.635.476.178.213.36.413.55.595.29.28.6.517.937.7a3.514 3.514 0 0 0 1.173-.951c-.302-.516-.567-1.156-.808-1.88",
    fill: "#175FAB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.632 14.848h-2.295l-.364.017-.17.362c-1.9 4.048-3.895 7.555-5.921 10.343-.953 2.932-1.651 4.711-2.509 5.757.367.626.793 1.065 1.3 1.252l.04-.009h.008l.028-.006.064-.016.038-.01.056-.015.036-.01.084-.026.042-.014.048-.017.048-.016.04-.015.1-.034.026-.01.061-.024.026-.01.213-.09h.007a5.89 5.89 0 0 0 .308-.148c3.294-1.841 4.958-8.024 10.128-17.26H42.63l.002-.001Z",
    fill: "url(#dotnet_svg__o)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m14.037 15.254.024.006.06.006h.02l.11.014.018.007.092.015.024.005.212.048.02.006.085.024.024.007.101.029.008.006.09.03.033.011.064.026.036.013.085.035.04.018.052.022.045.021.044.023c.367.18.705.42 1.018.712.115-.121.235-.23.36-.328a3.971 3.971 0 0 0-2.663-.747",
    fill: "#7DCBEC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.34 16.329c.192.178.375.377.549.591.168-.116.334-.229.501-.334a5.296 5.296 0 0 0-.69-.585 3.368 3.368 0 0 0-.36.328Z",
    fill: "#5EC5ED"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m13.938 15.278.312-.013a3.97 3.97 0 0 1 2.351.76c.722-.569 1.594-.768 2.806-.768H13.54l.398.021Z",
    fill: "url(#dotnet_svg__p)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.407 15.257c-1.212 0-2.082.2-2.805.769.238.168.47.365.689.585 1.005-.638 1.999-1.062 2.98-1.246.374-.07.747-.106 1.114-.106h-1.978v-.002Z",
    fill: "url(#dotnet_svg__q)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33.885 25.576c.521-1.607 1.117-3.557 1.857-5.923.667-2.131 1.847-3.725 4.064-4.42l.17-.363c-3.613.217-5.302 2.055-6.151 4.777-1.487 4.753-2.387 7.833-3.254 9.796 1.107-1.058 2.214-2.358 3.314-3.867Z",
    fill: "url(#dotnet_svg__r)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__a",
    x1: 21.186,
    y1: 15.114,
    x2: 21.186,
    y2: 37.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0994DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#127BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#127BCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__b",
    x1: 22.013,
    y1: 14.586,
    x2: 22.013,
    y2: 37.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E76BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__c",
    x1: 26.457,
    y1: 32.152,
    x2: 26.457,
    y2: 14.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C63B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#33BDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33BDF2",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__d",
    x1: 25.249,
    y1: 12.24,
    x2: 25.249,
    y2: 35.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#166AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#0798DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0798DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__e",
    x1: 23.527,
    y1: 12.422,
    x2: 23.527,
    y2: 37.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1487CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#165197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__f",
    x1: 13.286,
    y1: 19.761,
    x2: 16.794,
    y2: 19.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33BDF2",
    stopOpacity: 0.698
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DACD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__g",
    x1: 39.855,
    y1: 31.688,
    x2: 39.855,
    y2: 14.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#136AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#59CAF5",
    stopOpacity: 0.549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CAF5",
    stopOpacity: 0.235
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__h",
    x1: 0.834,
    y1: 23.924,
    x2: 13.849,
    y2: 23.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6",
    stopOpacity: 0.247
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__i",
    x1: 8.3,
    y1: 32.137,
    x2: 8.3,
    y2: 14.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#318ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38A7E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__j",
    x1: 9.26,
    y1: 32.231,
    x2: 9.26,
    y2: 14.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6",
    stopOpacity: 0.549
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__k",
    x1: 10.35,
    y1: 33.139,
    x2: 10.35,
    y2: 18.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1959A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#7EC5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EC5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__l",
    x1: 10.79,
    y1: 32.168,
    x2: 7.991,
    y2: 16.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D82CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__m",
    x1: 36.755,
    y1: 23.163,
    x2: 36.755,
    y2: 14.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#0495D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0495D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__n",
    x1: 40.798,
    y1: 14.134,
    x2: 37.425,
    y2: 33.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A7E4",
    stopOpacity: 0.329
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#0E88D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E88D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__o",
    x1: 37.615,
    y1: 14.816,
    x2: 37.615,
    y2: 32.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C87CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#154B8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__p",
    x1: 13.139,
    y1: 13.051,
    x2: 34.181,
    y2: 21.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#55C1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__q",
    x1: 18.86,
    y1: 17.99,
    x2: 35.48,
    y2: 10.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ACCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dotnet_svg__r",
    x1: 35.146,
    y1: 15.801,
    x2: 35.146,
    y2: 33.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ABE7",
    stopOpacity: 0
  })))));
};

export default SvgDotnet;